import React from 'react'

import './LoadingIcon.scss'

const LoadingIcon = () => {
    return (
        <div className="sn-loading-icon">
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="https://www.w3.org/2000/svg"
                xmlnsXlink="https://www.w3.org/1999/xlink"
                x="60px"
                y="60px"
                viewBox="0 0 75 75"
                enableBackground="new 0 0 75 75"
                xmlSpace="preserve"
                style={{ width: '60px', height: '60px' }}
            >
                <g>
                    <path
                        className="blue-sn-path"
                        style={{ fill: '#026AAD', stroke: '#026AAD', strokeWidth: 1 }}
                        d="M42.8,56.6c5.5-5.6,18.9-0.5,20.2-0.7c0.7-0.1,1-1.1-0.4-1.6c-13.2-5.3-32.8-6.6-43.5-4.7
          c-1.2,0.3-1.6,1.4,0.3,1.6c1.9,0.2,6.6,0.6,13.5,2.2c3.8,0.9,6.6,2.1,9,3.4C42.2,57,42.5,56.9,42.8,56.6"
                    />
                    <path
                        className="red-sn-path"
                        style={{ fill: '#C8202F', stroke: '#C8202F', strokeWidth: 1 }}
                        d="M64.2,51.6l1.1-5.3c-20.8-6.3-40.7-6-61.7,1.5c-1.1,0.4-1.4,1.9,0.8,1.6c3.2-0.5,16.3-2.3,27.9-2.3
          c9.3,0,20.6,1.9,30.1,5C63.5,52.4,64,52.2,64.2,51.6z"
                    />
                    <g>
                        <path
                            className="n-sn-path"
                            style={{ fill: '#000', stroke: '#000', strokeWidth: 1 }}
                            d="M62.5,18l-3.4,15.9h-0.1L54.5,18H37.4l-1.5,7h2.5l-3.1,14.5c0.5,0,0.9,0,1.4,0c2.4,0,4.8,0.1,7.2,0.3
            l3.2-15h0.1l4.6,15.9c4.6,0.7,9.2,1.8,13.9,3.2c0,0,0,0,0.1,0l5.5-26H62.5z"
                        />
                        <path
                            className="s-sn-path"
                            style={{ fill: '#000', stroke: '#000', strokeWidth: 1 }}
                            d="M34.7,25c0.9-4.9-1.5-7.7-11.6-7.7c-9.5,0-14.7,2.3-15.8,7.5C6.9,26.2,7,27.9,8,29
            c2.6,2.8,13.7,3.9,14.7,5.4c0.2,0.3,0.3,0.7,0.2,1.1c-0.4,1.9-2.7,2.4-4.8,2.4c-1.3,0-2.1-0.3-2.7-1c-0.5-0.6-0.6-1.6-0.3-2.9H5
            c-0.7,4.1-0.9,7.7,9.4,8.2c5.1-1.2,10.1-2,15.2-2.4c2.2-1.3,3.4-3.1,3.9-5.2c0.5-2.3-0.2-3.6-0.9-4.4C30,27.4,19.3,26.3,18,24.8
            c-0.2-0.3-0.3-0.7-0.2-1.1c0.3-1.2,1.5-2,3.6-2c1.2,0,2.2,0.2,2.8,0.7c0.6,0.5,0.9,1.3,0.7,2.6H34.7z"
                        />
                    </g>
                </g>
            </svg>
        </div>
    )
}

export default LoadingIcon
